import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Outlet, useNavigate, RouterProvider, createBrowserRouter, useLocation, Navigate } from 'react-router';

import { HeroUIProvider, ToastProvider } from '@heroui/react';

import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material';
import { THEME_ID } from '@mui/material/styles';

import { AuthProvider, useAuth } from './hooks/useAuth';  // Correct import for the custom hook
import SignIn from './pages/SignIn';
import Jobs from './pages/Jobs/Jobs';

import "./css/tailwind.css"
import "./css/styles.min.css"
import { Screen, Column, Row } from './components/Layout';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import useHeaderTextStore from './hooks/useHeaderText';
import Logs from './pages/Logs';
import Health from './pages/Health';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
  {
    Component: App,
    children: [
      {
        path: '/',
        Component: AppMain,
        children: [
          {
            path: '/',
            Component: Jobs,
          },
          {
            path: '/dashboard',
            Component: Dashboard,
          },
          {
            path: '/logs',
            Component: Logs,
          },
          {
            path: '/health',
            Component: Health,
          },
        ]
      },
      {
        path: '/sign-in',
        Component: SignIn,
      },
    ],
  },
]);

const theme = createTheme({
  palette: {
    mode: 'dark' // For the sign-in page
  },
  components: {
    MuiStack: {
      defaultProps: {
        gap: 1,
      },
    },
  },
});

function App() {
  return (
    <main className="dark text-foreground bg-background">
      <HeroUIProvider>
        <ToastProvider placement='bottom-center' />
        <MuiThemeProvider theme={{ [THEME_ID]: theme }}>
          {/* <main> */}
          <Outlet />
        </MuiThemeProvider>
      </HeroUIProvider>
    </main>
  );
}

function AppMain() {


  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  const { setHeaderText } = useHeaderTextStore()
  useEffect(() => {
    setHeaderText({
      heading: "",
      title: ""
    })
  }, [])

  if (loading) {
    return <div></div>; // Or a spinner if you want
  }
  if (!isAuthenticated) {
    const redirectTo = `/sign-in?callbackUrl=${encodeURIComponent(location.pathname)}`;
    return <Navigate to={redirectTo} replace />;
  }


  const sidebarWidth = 15;
  const sidebarWidthStr = `${sidebarWidth}%`
  const contentWidthStr = `${100 - sidebarWidth}%`

  return (
    <Screen>
      <Row fullHeight>
        {/* <Sidebar width={sidebarWidthStr} /> */}
        {/* <Column width={contentWidthStr}> */}
        <Column expand>
          <Header />
          <Outlet />
        </Column>
      </Row>
    </Screen>
  )
}

root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
